import shareholderTypes from 'Constants/shareholder-types';

export default {
    [shareholderTypes.REGISTERED]: 'font-icon-registered',
    [shareholderTypes.INSTITUTION]: 'font-icon-institution',
    [shareholderTypes.INSIDER]: 'font-icon-insider'
};
